import { useState } from "react";
import { storage } from "../utils";

export default function useLocalStorage(key, initialValue, isJson = true) {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = storage.getItem(key);
      const checkForBoolean = (string) => {
        if(string === "true") return true;
        if(string === "false") return false;
        return string;
      }
      // Log the string before trying to parse it.
      // Parse the item as JSON if isJson is true; otherwise, return the item as is.
      return item && item !== "undefined"
        ? isJson
          ? JSON.parse(item)
          : checkForBoolean(item) 
        : initialValue;
    } catch (error) {
      console.error('Error parsing useLocalStorage', error);
      return initialValue;
    }
  });

  const setValue = (value) => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      // Stringify the value before storing it if isJson is true; otherwise, store the value as is.
      storage.setItem(
        key,
        isJson ? JSON.stringify(valueToStore) : valueToStore
      );
    } catch (error) {
      // console.warn(error);
    }
  };

  return [storedValue, setValue];
}
